import React from "react";
import { Button } from "react-bootstrap";
import ReactInicis from "components/Common/Inicis/ReactInicis";
import { PayPalButton } from "react-paypal-button-v2";
import { getPaypalOptions } from "src/utils/pay/insertPaypalModule";
import { useFormContext } from "react-hook-form";
import { createServiceBill, sendPaypalSuccessMail } from "src/service/pay";
import { userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { notifyError } from "src/components/Common/Toast";
import { useRouter } from "src/hooks/useRouter";
import { useTranslation } from "react-i18next";

interface CardPaymentProps {
  payCompany: "INICIS" | "PAYPAL" | string;
  inicisData: any;
  currency: string;
  setGoodName: () => string;
  paypalSubscription: any;
}

const CardPayment: React.FC<CardPaymentProps> = ({
  payCompany,
  inicisData,
  currency,
  setGoodName,
  paypalSubscription,
}) => {
  const { watch, trigger, getValues } = useFormContext();
  const confirmPolicy = watch("confirmPolicy");
  const [userInfo] = useRecoilState(userInfoAtom);
  const route = useRouter();
  const { t } = useTranslation();

  // 결제창을 열기 전에 폼 검증 — 검증 실패 시 구독을 만들지 않는다
  const createSubscription = async (data: any, actions: any) => {
    if (!(await trigger())) throw new Error("invalid form");
    return paypalSubscription(data, actions);
  };

  // PayPal 승인 후 청구서(UNLINK) 생성 → 콘솔에서 사이트 생성 모달로 이어진다
  // ponytail: 서버 측 구독 검증 없음(/service/bill/new). 백엔드 PayPal 검증 API 생기면 교체
  const handlePaypalApprove = async (data: {
    orderID: string;
    subscriptionID: string;
  }) => {
    const values = getValues();
    try {
      const res = await createServiceBill({
        serviceBillUid: "", // 신규 구독
        userCode: userInfo.userCode,
        billType: "PAY",
        billCode: values.priceUid, // price의 uid값 전달
        licenseCount: values.licenseCount,
        orderID: data.orderID,
        subscriptionID: data.subscriptionID,
        payTerm: values.payTerm,
        oldSubscriptionID: "",
        currency: "USD",
        payCompany: "PAYPAL",
        referralId: values.referralId,
        totalPrice: values.totalPrice,
      });
      if (res?.status !== 200) throw res;
      sendPaypalSuccessMail({ subscriptionId: data.subscriptionID });
      route.goConsole();
    } catch {
      // 결제는 완료됐으므로 구독 ID를 안내해 수동 처리할 수 있게 한다
      notifyError(
        t("common.alert.paypalBillFail", { id: data.subscriptionID })
      );
    }
  };

  if (payCompany === "INICIS") {
    return (
      <ReactInicis
        payData={inicisData}
        currency={currency}
        goodName={setGoodName()}
      >
        <Button
          variant="success"
          // className="w-100 mt-3 d-flex justify-content-center align-items-center"
          className="btn btn-green btn-40 width w-100p mg mt-20 pd py-10"
          // 서명 데이터(inicisData)가 현재 폼 값 기준으로 갱신되기 전에는 결제 불가
          disabled={!confirmPolicy || !inicisData}
        >
          <img
            src="/resources/images/card.png"
            alt="card"
            width={16}
            height={12}
            className="me-2"
          />
          {t("common.card")}
        </Button>
      </ReactInicis>
    );
  }

  if (payCompany === "PAYPAL") {
    return (
      // 약관 동의 전에는 클릭 불가 (이니시스 버튼 disabled와 동일)
      <div
        className={confirmPolicy ? "mg mt-20" : "mg mt-20 none-click"}
        style={confirmPolicy ? undefined : { opacity: 0.5 }}
      >
        <PayPalButton
          options={getPaypalOptions()}
          createSubscription={createSubscription}
          onApprove={handlePaypalApprove}
          currency={"USD"}
        />
      </div>
    );
  }

  return null;
};

export default CardPayment;
